document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.js-em-section');

  sections.forEach(section => {
    const tiltElement = section.querySelector('.js-em-tilt');
    const parallaxBg = section.querySelector('.js-em-parallax');

    // --- EFFETTO TILT 3D (Solo Desktop) ---
    if (tiltElement && window.innerWidth > 768) {
      tiltElement.addEventListener('mousemove', (e) => {
        // Calcola la posizione del mouse relativa al centro della card
        const rect = tiltElement.getBoundingClientRect();
        const x = e.clientX - rect.left; // X rispetto all'elemento
        const y = e.clientY - rect.top;  // Y rispetto all'elemento
        
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        
        // Calcola la rotazione (più ti allontani dal centro, più ruota)
        // Divisore alto = effetto più morbido.
        const rotateX = ((y - centerY) / centerY) * -8; // Max 8 gradi
        const rotateY = ((x - centerX) / centerX) * 8;  // Max 8 gradi

        tiltElement.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`;
      });

      // Quando il mouse esce, la card torna dolcemente piatta
      tiltElement.addEventListener('mouseleave', () => {
        tiltElement.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)`;
      });
    }

    // --- EFFETTO PARALLASSE SFONDO ---
    if (parallaxBg) {
      window.addEventListener('scroll', () => {
        const scrollPos = window.scrollY;
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;

        // Anima solo se la sezione è visibile
        if (scrollPos + window.innerHeight > sectionTop && scrollPos < sectionTop + sectionHeight) {
          const yPos = (scrollPos - sectionTop) * 0.15; // Velocità parallasse
          parallaxBg.style.transform = `translateY(${yPos}px)`;
        }
      }, { passive: true });
    }
  });
});